module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-row', {
    staticClass: "margin-b-10 margin-10 padding-t-20",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "ml-3",
    attrs: {
      "sm": 8
    }
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('static.exciseEntry.filters.label')) + ":\n            ")]), _vm._v(" "), _c('v-form', {
    staticClass: "excise-entry-filters",
    attrs: {
      "form": _vm.form,
      "translation": "form.exciseEntry",
      "hasLabel": true,
      "inline": true
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "margin-b-10 margin-10",
    attrs: {
      "gutter": 24
    }
  }, [(_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('el-col', {
    attrs: {
      "sm": 24
    }
  }, [_c('v-excise-table', {
    attrs: {
      "list": _vm.entries,
      "noDataMessage": _vm.$t('static.defaultText.exciseEntry.noDataMsg'),
      "translation": "static.exciseEntry.table",
      "loading": _vm.loading,
      "update_list": _vm.updateList,
      "link": _vm.openLink
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "pagination"
  }, [_c('v-pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "sizePerPage": _vm.perPage,
      "switchFunction": _vm.all
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dbf005b","hasScoped":true}!./src/app/components/exciseEntry/exciseEntry.html
// module id = 2955
// module chunks = 1